export default {"src":"/a/r/be1.10/_next/static/media/round-pin.2f36cba7.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};